<div *ngIf="show" class="ribbon">
  <p [ngClass]="[env, rightOrLeft]">{{message}}</p>
</div>
